export default __webpack_public_path__ + "static/media/logo_min.efc81b9e.png";